import React from 'react'
// components
import { ReduxSelect } from 'components/FormElements'
// types
import { FieldSource, FieldType } from 'types/graphql'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// utils
import { required } from 'utils/validators'

interface Props {
  field: string
}

const RestrictRecord: React.FC<Props> = ({ field }) => {
  const { riskTemplate, basicFields } = React.useContext(RiskTemplateAPIContext)

  const options = riskTemplate?.fields
    ?.filter(
      ({ fieldType, source }) =>
        fieldType === FieldType.Lookup && source.some((s) => [FieldSource.Users, FieldSource.Positions].includes(s))
    )
    .map((item) => ({
      label: item.parentFieldId
        ? `${basicFields.find((f) => f.id === item.parentFieldId)?.label}: ${item.label}`
        : item.label,
      value: item.id
    }))

  return (
    <div style={{ width: '50%' }}>
      <ReduxSelect
        options={options}
        validate={required}
        menuPortalTarget={null}
        name={`${field}.restrictFieldId`}
        label='User/Position Lookup'
      />
    </div>
  )
}

export default RestrictRecord
